import { CsobFormMetaDataDto } from "@green0meter/api-client";
import { create } from "zustand";

type CsobQuestionnaireStore = {
  forms: CsobFormMetaDataDto[];
  setForms: (forms: CsobFormMetaDataDto[]) => void;
  shakeTableActive: boolean;
  shakeTable: () => void;
};

export const useCsobQuestionnaireStore = create<CsobQuestionnaireStore>((set) => ({
  forms: [],
  setForms: (forms: CsobFormMetaDataDto[]): void => set({ forms }),
  shakeTableActive: false,
  shakeTable: (): void => {
    set({ shakeTableActive: true });

    setTimeout(() => set({ shakeTableActive: false }), 600);
  },
}));
